module.exports = __webpack_public_path__ + "static/img/success17.f2067527.png";